import { hashKey } from "@tanstack/react-query";
import { userStateQueryKey } from "./userStateQueryKeys";

/**
 * True only for the one query TEC-404's guest-mode persister persists to IndexedDB across
 * browser sessions — the user-state map (`userStateQueryKey`).
 *
 * Identity (`userQueryKey`, see `query/user/useUserQuery.ts`) is deliberately excluded: it
 * should always resolve fresh from the session cookie on every page load, never be restored from
 * a browser-local cache. Persisting "signed in as X" client-side indefinitely is a
 * staleness/security smell — a stale identity snapshot could outlive a server-side sign-out, or
 * (on a shared machine) leak one person's signed-in state to the next.
 *
 * Pulled out as a standalone, framework-free predicate (rather than inlined in
 * `dehydrateOptions.shouldDehydrateQuery`) so it can be unit tested directly — this repo has no
 * renderHook harness, see `userStateOptimisticQuery.ts` for the same pattern.
 */
export function isPersistedUserStateQuery(queryKey: readonly unknown[]): boolean {
  return hashKey(queryKey as unknown[]) === hashKey(userStateQueryKey as unknown[]);
}
